import { Sprite, Texture } from 'pixi.js';

// Radial-gradient red vignette overlay that pulses faster + brighter as HP approaches 0.
// Owns its own baked texture + Sprite. main.ts adds `.view` to stage and calls `tick(dt, hpFrac, W, H)`.
export class LowHpVignette {
  view: Sprite;
  private pulseT = 0;

  constructor() {
    const c = document.createElement('canvas');
    c.width = 512; c.height = 512;
    const ctx = c.getContext('2d')!;
    const grd = ctx.createRadialGradient(256, 256, 90, 256, 256, 360);
    grd.addColorStop(0, 'rgba(255,0,0,0)');
    grd.addColorStop(0.55, 'rgba(255,30,30,0.15)');
    grd.addColorStop(1, 'rgba(255,30,30,0.95)');
    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, 512, 512);
    this.view = new Sprite(Texture.from(c));
    this.view.anchor.set(0);
    this.view.alpha = 0;
  }

  tick(dt: number, hpFrac: number, W: number, H: number): void {
    const danger = Math.max(0, 0.5 - hpFrac) * 2; // 0 above 50%, 1 at 0
    if (danger > 0.001) {
      this.pulseT += dt * (3 + danger * 4);
      const base = danger * 0.6;
      const pulse = base * (0.7 + 0.3 * Math.sin(this.pulseT));
      this.view.alpha = pulse;
      this.view.width = W;
      this.view.height = H;
    } else if (this.view.alpha !== 0) {
      this.view.alpha = 0;
    }
  }
}
